export const CurriculoEscolar = {
 
}